import { prospectusEpic } from './epic'
import { prospectusReducer } from './reducer'

export const prospectEpic = prospectusEpic
export const prospectReducer = prospectusReducer
